import { Injectable } from '@angular/core';
import { RealTimeFinancialHealthReportPdfRequest } from 'app/internal/reports/shared/models/real-time-financial-health-report-pdf-request';
import { AnalyticsFileFormat, AnalyticsReportType, AnalyticsService, ApiHelperService, ApiService, BlobWithFilename } from 'app/shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  endpointUrl: string;

  constructor(private api: ApiService,
    private analyticsService: AnalyticsService,
    { reportsServiceUrl }: ApiHelperService) {
    this.endpointUrl = `${reportsServiceUrl}/api/reports`;
  }

  generateDashboardPdf(reportRequest: RealTimeFinancialHealthReportPdfRequest): Observable<BlobWithFilename> {
    this.analyticsService.reportExportedEvent(AnalyticsFileFormat.Pdf, AnalyticsReportType.IntegratedDashboard);

    const url =
      `${this.endpointUrl}/realtimefinancialhealth/${reportRequest.propertyId}/${reportRequest.fiscalYear}/pdf`;

    return this.api.postBlobWithFileNameUsingFormData(url, reportRequest.dxPngFormData, 'application/pdf');
  }
}
